import { DrillAggregatesDto, DrillDetailDto } from '@drills/infra';
import { DrillAggregatesViewModel, DrillDetailViewModel } from '../models';
import { toDrillSessionPreviewViewModel, toDrillViewModel } from './drill.view-model.mapper';

const toDrillAggregatesViewModel = (dto: DrillAggregatesDto): DrillAggregatesViewModel => ({
  sessionsCount: dto.sessionsCount,
  activeDaysCount: dto.activeDaysCount,
  totalRuns: dto.totalRuns,
  lastUsedAt: dto.lastUsedAt === null ? null : new Date(dto.lastUsedAt),
  bestResultLabel: dto.bestResultLabel
});

export const toDrillDetailViewModel = (dto: DrillDetailDto): DrillDetailViewModel => ({
  ...toDrillViewModel(dto),
  aggregates: toDrillAggregatesViewModel(dto.aggregates),
  bestSessions: dto.bestSessions.map(toDrillSessionPreviewViewModel)
});
